import { render, staticRenderFns } from "./ProjectModalResume.vue?vue&type=template&id=1522b9a2&scoped=true&"
import script from "./ProjectModalResume.vue?vue&type=script&lang=js&"
export * from "./ProjectModalResume.vue?vue&type=script&lang=js&"
import style0 from "./ProjectModalResume.vue?vue&type=style&index=0&id=1522b9a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522b9a2",
  null
  
)

export default component.exports